export default {
    areaCode:'+62',//手机区号
}